import request from '@/utils/request'

//同步小睿的书籍的清单
export function sync_books_list(){
    return request({
        url: '/edas/sync/books_list',
        method: 'get',
        params: ''
    });
}


//从小睿同步拉取新的数据
export function sync_newbooks(bookidStr){
    return request({
        url: '/edas/sync/newbooks',
        method: 'post',
        data: {
            bookidStr : bookidStr
        }
    });
}

//同步获取小睿对应书本的题目数据
export function sync_book_question(bookidStr){
    return request({
        url: '/edas/sync/xr_questions',
        method: 'post',
        data: {
            bookidStr : bookidStr
        }
    });
}


//同步获取小睿对应书本的题目数据--详情数据
export function sync_book_question_detail(bookidStr){
    return request({
        url: '/edas/sync/xr_questions_detail',
        method: 'post',
        data: {
            bookidStr : bookidStr
        }
    });
}


//加载可以进行匹配关联的 教辅书列表
export function load_anwu_books() {
    return request({
        url: '/edas/datas/books_aw',
        method: 'get',
        params: ''
    })
}



// WEBPACK FOOTER //
// ./src/api/xrsync.js